var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.receiptIssueDate)?_c('span',[_vm._v("\n    "+_vm._s(_vm.receiptIssueDate)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }